<form style="position: relative">
	<p class="c-text c-text--bold u-ost-md u-osb-md" *ngIf="vm.prescriptionBooking || !vm.minudocExtraConsentsDisabled">{{ 'Modal.Content.Consent_State' | translate }}:</p>
	<div class="c-form__group u-osb-sm" *ngIf="!vm.isBookingConsent && vm.user?.personalCode">
		<label class="c-checkbox">
			<input id="xroadHealthInsuranceAccessGrantedCheckbox" name="xroadHealthInsuranceAccessGrantedCheckbox" type="checkbox" [(ngModel)]="vm.consent.xroadHealthInsuranceAccessGranted">
			<span id="xroadHealthInsuranceAccessGrantedLabel">{{ 'Modal.Content.X_Road_Insurance_Access_Consent' | translate }}</span>
		</label>
	</div>
	<div class="c-form__group u-osb-sm" *ngIf="!vm.isBookingConsent && vm.user?.personalCode">
		<label class="c-checkbox">
			<input id="xroadPrescriptionsAccessGrantedCheckbox" name="xroadPrescriptionsAccessGrantedCheckbox" type="checkbox" [(ngModel)]="vm.consent.xroadPrescriptionsAccessGranted">
			<span id="xroadPrescriptionsAccessGrantedLabel">{{ 'Modal.Content.X_Road_Prescriptions_Access_Consent' | translate }}</span>
		</label>
	</div>
	
	<div class="c-form__group u-osb-sm" *ngIf="vm.prescriptionBooking">
		<label class="c-checkbox">
			<input id="pharmacyDataSharingAcceptedCheckbox" name="pharmacyDataSharingAcceptedCheckbox" type="checkbox" [(ngModel)]="vm.consent.pharmacyDataSharingAccepted" [disabled]="!vm.consent.pharmacyDataSharingAccepted">
			<span id="pharmacyDataSharingAcceptedLabel">{{ 'Pharmacy_Redirect.Consent_Data_Sharing' | translate }}</span>
		</label>
	</div>
	<div class="c-form__group u-osb-sm" *ngIf="vm.prescriptionBooking">
		<label class="c-checkbox">
			<input id="pharmacyDataProcessingAcceptedCheckbox" name="pharmacyDataProcessingAcceptedCheckbox" type="checkbox" [(ngModel)]="vm.consent.pharmacyDataProcessingAccepted" [disabled]="!vm.consent.pharmacyDataProcessingAccepted">
			<span id="pharmacyDataProcessingAcceptedLabel">{{ 'Pharmacy_Redirect.Consent_Data_Processing' | translate }}</span>
		</label>
	</div>
	
	<div class="c-form__group u-osb-sm" *ngIf="vm.isBookingConsent && !vm.minudocExtraConsentsDisabled">
		<label class="c-checkbox">
			<input id="dataProcessingAcceptedCheckbox" name="dataProcessingAcceptedCheckbox" type="checkbox" [(ngModel)]="vm.consent.dataProcessingAccepted" [disabled]="!vm.consent.dataProcessingAccepted">
			<span id="dataProcessingAcceptedLabel">{{ 'Modal.Content.Data_Processing' | translate }}</span>
		</label>
	</div>
	<div class="c-form__group u-osb-sm" *ngIf="vm.isBookingConsent && !vm.minudocExtraConsentsDisabled">
		<label class="c-checkbox">
			<input id="dataSharingAcceptedCheckbox" name="dataSharingAcceptedCheckbox" type="checkbox" [(ngModel)]="vm.consent.dataSharingAccepted" [disabled]="!vm.consent.dataSharingAccepted">
			<span id="dataSharingAcceptedLabel">{{ 'Modal.Content.Data_Sharing_Accepted' | translate }}</span>
		</label>
	</div>
	<div class="c-form__group" *ngIf="vm.isBookingConsent && !vm.minudocExtraConsentsDisabled">
		<label class="c-checkbox">
			<input id="dataStorageTimeAcceptedCheckbox" name="dataStorageTimeAcceptedCheckbox" type="checkbox" [(ngModel)]="vm.consent.dataStorageTimeAccepted" [disabled]="!vm.consent.dataStorageTimeAccepted">
			<span id="dataStorageTimeAcceptedLabel">{{ 'Modal.Content.Data_Storage_Time' | translate }}</span>
		</label>
	</div>

	<loader-overlay *ngIf="vm.loading" [theme]="3"></loader-overlay>
</form>
<div class="o-grid">
	<div *ngIf="vm.prescriptionBooking || !vm.minudocExtraConsentsDisabled" class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
		<button id="updateConsentsButton" type="button" class="c-button c-button--s2 c-button--fit" (click)="vm.updateConsents()" [disabled]="vm.loading || vm.btnDisabled">{{ 'Modal.Button.Update' | translate }}</button>
	</div>
</div>
